import {
  PROFESSIONALS_FETCHED_SUCCESS,
  PROFESSIONALS_FETCHED_FAILURE,
} from '../actions/types';

const initialState = 'NONE';

export default function professionalsFetchedReducer(
  state = initialState,
  action,
) {
  const { type, payload } = action;
  switch (type) {
    case PROFESSIONALS_FETCHED_SUCCESS:
      return payload;
    case PROFESSIONALS_FETCHED_FAILURE:
      return 'NONE';

    default:
      return state;
  }
}
